/**
 * theme for MUI
 * TODO: create a theme object as per designs
 */
import { ptBR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';
import { desaturate } from 'polished';
import type {} from '@mui/lab/themeAugmentation';
import type {} from '@mui/x-data-grid/themeAugmentation';
import logoNiteroiRotativo from '../assets/images/logo_niteroi_rotativo.png';

// export const logo = logoNiteroiRotativo;
export const logo = process.env.REACT_APP_LOGO_URL || logoNiteroiRotativo;
export const title = process.env.REACT_APP_TITLE || 'Zona Azul';

export const screenBreakpoints = {
  xs: 0, // smartphones: up to 425px
  sm: 426, // tablets: from 425px to 768px
  md: 769, // laptops: from 768px to 1024px
  lg: 1025, // large laptops and desktops: from 1024px to 1440px
  xl: 2561, // 4k: above 1024px
}

const PRIMARY_COLOR = process.env.REACT_APP_PRIMARY_COLOR || '#721B7D';
const SECONDARY_COLOR = process.env.REACT_APP_SECONDARY_COLOR || '#FF7300';
const TEXT_COLOR = process.env.REACT_APP_TEXT_COLOR || '#666666';
const BACKGROUND_COLOR = process.env.REACT_APP_BACKGROUND_COLOR || '#c0c0c0';

export const theme = createTheme(
  {
    breakpoints: {
      values: {
        xs: screenBreakpoints.xs,
        sm: screenBreakpoints.sm,
        md: screenBreakpoints.md,
        lg: screenBreakpoints.lg,
        xl: screenBreakpoints.xl,
      },
    },
    palette: {
      mode: 'light',
      primary: {
        main: PRIMARY_COLOR,
        contrastText: '#fff',
      },
      secondary: {
        main: SECONDARY_COLOR,
        contrastText: '#fff',
      },
      error: {
        main: '#e62929',
        contrastText: '#fff',
      },
      success: {
        main: '#1aca3d',
        contrastText: '#fff',
      },
      warning: {
        main: '#e8d22e',
        contrastText: '#fff',
      },
      divider: '#e0e0e0',
      text: {
        main: TEXT_COLOR,
        contrastText: '#fff',
      },
      background: {
        main: BACKGROUND_COLOR,
        contrastText: '#000',
      },
      action: {
        disabledBackground: desaturate(0.5, '#FF7300'),
        // disabled: 'set color of text here'
      },
    },
    components: {
      MuiTypography: {
        defaultProps: {
          variantMapping: {
            h1: 'h2',
            h2: 'h2',
            h3: 'h2',
            h4: 'h2',
            h5: 'h2',
            h6: 'h2',
            subtitle1: 'h2',
            subtitle2: 'h2',
            body1: 'span',
            body2: 'span',
          },
        },
      },
    },
    typography: {
      button: {
        textTransform: 'none',
        // Using this will stop tranforming all button texts to UPPERCASE
      },
    },
  },
  ptBR,
);

export const palette = theme.palette;